import Dialog from "../Dialog";
import CloseButton from "../CloseButton";
import App from "../../../App";

const AD_TYPE = {
    RV: 94,
    IV: 287,
}

const IV_REWARD_MODE = {
    CLOSE_MODE: 0,
    PLAY_MODE: 1,
}

const IV_REWARD_PLAY_VALUE_MODE = {
    ALERT_RATE: 0, // 0 ~ 1
    ALERT_TIME: 1, // 0 ~ 100(s)
}

// 用来标识用户是否曾经主动隐藏过关闭按钮（如：点击了 IV 弹窗中的 "继续"）
let videoCloseButtonHideByUser = false

class SingleVideoRewardManager {

    static init({ad_type, appSetting, unitSetting, videoElement, currentCampaign} = {}) {

        // TODO: mock data
        /*Object.assign(unitSetting, {
            close_alert: 1,
            "endscreen_type": 2,
            "video_skip_time": 10,
            "video_skip_result": 2, // TODO endcard 跳转
        })
        Object.assign(appSetting, {
            ivreward: {
                ivRewardEnable: 1,
                ivRewardMode: 1, //CLOSE_MODE: 0, PLAY_MODE: 1,
                ivRewardPlayValueMode: 0, // ALERT_RATE: 0, // 0 ~ 1; ALERT_TIME: 1, // 0 ~ 100(s)
                ivRewardPlayValue: 0.2,
            }
        })*/

        console.log('=-========================', {ad_type, appSetting, unitSetting, videoElement, currentCampaign})

        // 初始化关闭按钮出现倒计时
        let videoCloseButton = this.initVideoCloseButton({appSetting, unitSetting});

        // 初始化点击关闭按钮时，弹窗奖励等逻辑
        if (ad_type === AD_TYPE.RV) {
            console.log('=-= ad_type: RV ', ad_type)
            // 如果 RV 设置启用了关闭提示，则在点击关闭按钮时出现弹窗
            if (this.RVCloseAlertEnabled(unitSetting)) {
                console.log('RV 设置启用了关闭提示，则在点击关闭按钮时出现弹窗')
                this.initRVReward({appSetting, videoCloseButton, videoElement})
            } else {
                // 否则点击关闭按钮时不再出现弹窗
                console.warn('=-= 当前配置了不展示 RV 弹窗，点击关闭按钮时不再出弹窗')
                videoCloseButton.onClick(e => {
                    // TODO: 根据关闭的时间，处理 RV 奖励等相关业务
                    this.closeVideoTemplate()
                })
            }
        } else if (ad_type === AD_TYPE.IV) {
            console.log('=-= ad_type: IV ', ad_type)
            // 如果 IV 设置启用了奖励弹窗，则在点击关闭按钮时出现弹窗
            if (this.IVRewardEnabled(appSetting)) {
                this.initIVReward({appSetting, videoCloseButton, videoElement, currentCampaign})
            } else {
                // 否则点击关闭按钮时不再出现弹窗
                console.warn('=-= 当前配置了不展示 RV 弹窗，点击关闭按钮时不再出弹窗')
                videoCloseButton.onClick(e => {
                    // TODO: 根据关闭的时间，处理 IV 相关业务
                    this.closeVideoTemplate()
                })
            }
        } else {
            // TODO 如果检测到其他 ad_type，是否需要支持最基础的关闭/跳转ec？
            console.error('=-= 当前指定的 ad_type 无效，请检查', ad_type, appSetting, unitSetting, videoElement)
        }
    }

    static initRVReward({appSetting, videoCloseButton, videoElement}) {
        // 初始化 rv dialog
        let {confirm_title, confirm_description, confirm_t, confirm_c_rv} = appSetting
        let RVDialog = new Dialog({
            // closable: true,
            titleCenter: true,
            title: confirm_title || '确认关闭？',
            content: confirm_description || '关闭后您将不会获得任何奖励',
            buttonGroup: [{
                text: confirm_t || '确认关闭',
                onClick: (e) => {
                    e.stopPropagation()
                    // TODO 关闭视频模板并根据配置走跳转 ec 或其他业务
                    videoElement.pause()
                    App.closeAd()
                    RVDialog.hide()
                }
            }, {
                text: confirm_c_rv || '继续观看',
                onClick: (e) => {
                    e.stopPropagation()
                    // TODO 恢复视频播放
                    videoElement.play()
                    RVDialog.hide()
                }
            }]
        })
        videoCloseButton.onClick(e => {
            videoElement.pause()
            RVDialog.show()
        })
    }

    static initIVReward({appSetting, videoCloseButton, videoElement, currentCampaign}) {
        let ivreward = appSetting && appSetting.ivreward
        let ivRewardEnabled = ivreward && ivreward.ivRewardEnable === 1
        let ivRewardMode = ivreward && ivreward.ivRewardMode
        let ivRewardPlayValueMode = ivreward && ivreward.ivRewardPlayValueMode
        let ivRewardPlayValue = ivreward && ivreward.ivRewardPlayValue

        // appSetting.ivreward.ivRewardEnable=1 表示启用 iv 弹窗，其他情况下不再初始化 IV 弹窗逻辑
        if (!ivRewardEnabled) {
            console.log('=-= IV 弹窗没有启用，不再初始化后续逻辑', ivRewardEnabled, ivreward && ivreward.ivRewardEnable)
            return false
        }
        console.log('=-= IV 弹窗已启用', ivreward)

        // 初始化 IV 弹窗
        let {confirm_title, confirm_description, confirm_t, confirm_c_rv} = appSetting
        let IVDialog = new Dialog({
            title: confirm_title || 'Continue?',
            content: confirm_description || 'If you continue, you can have reward when ad close.',
            buttonGroup: [{
                text: confirm_t || 'Cancel',
                onClick: (e) => {
                    e.stopPropagation()
                    this.closeVideoTemplate(IVDialog);
                }
            }, {
                text: confirm_c_rv || 'Continue',
                onClick: (e) => {
                    e.stopPropagation()
                    // TODO 恢复视频播放
                    videoElement.play()
                    // 隐藏弹窗
                    IVDialog.hide()
                    // 隐藏关闭按钮
                    videoCloseButton.hide()
                    videoCloseButtonHideByUser = true
                }
            }]
        })

        // 初始化 closeMode / playMode
        if (ivRewardMode === IV_REWARD_MODE.CLOSE_MODE) {
            switch (ivRewardPlayValueMode) {
                case IV_REWARD_PLAY_VALUE_MODE.ALERT_RATE:
                    // 点击关闭按钮时，如果达到指定的播放进度百分比，就直接关闭视频(TODO 是否需要回调开发者给奖励？)
                    console.log('=-= 点击关闭按钮时，如果达到指定的播放进度百分比，就直接关闭视频', ivreward)
                    videoCloseButton.onClick(e => {
                        if (videoElement.currentTime / currentCampaign.video_length >= ivRewardPlayValue) {
                            this.closeVideoTemplate(IVDialog)
                        } else {
                            videoElement.pause()
                            IVDialog.show()
                        }
                    })
                    break;
                case IV_REWARD_PLAY_VALUE_MODE.ALERT_TIME:
                    // 点击关闭按钮时，如果达到指定的播放时间，就直接关闭视频(TODO 是否需要回调开发者给奖励？)
                    console.log('=-= 点击关闭按钮时，如果达到指定的播放时间，就直接关闭视频', ivreward)
                    videoCloseButton.onClick(e => {
                        if (videoElement.currentTime >= ivRewardPlayValue) {
                            this.closeVideoTemplate(IVDialog)
                        } else {
                            videoElement.pause()
                            IVDialog.show()
                        }
                    })
                    break;
                default:
                    console.warn('=-= 无法识别的 playMode，不再初始化后续逻辑')
                    break;
            }
        } else if (ivRewardMode === IV_REWARD_MODE.PLAY_MODE) {
            let triggerTime, dialogHasNotShowOnce = true
            switch (ivRewardPlayValueMode) {
                case IV_REWARD_PLAY_VALUE_MODE.ALERT_RATE:
                    // 视频播放进度满足指定的百分比时，自动暂停视频并出现弹窗
                    triggerTime = currentCampaign.video_length * ivRewardPlayValue
                    console.log('=-= 视频播放进度满足指定的百分比时，自动暂停视频并出现弹窗', triggerTime, currentCampaign.video_length, ivreward)
                    videoElement.addEventListener('timeupdate', e => {
                        if (dialogHasNotShowOnce && videoElement.currentTime >= triggerTime) {
                            dialogHasNotShowOnce = false
                            videoElement.pause()
                            IVDialog.show()
                        }
                    })
                    break;
                case IV_REWARD_PLAY_VALUE_MODE.ALERT_TIME:
                    // 视频播放固定一段时间，自动暂停视频并出现弹窗
                    triggerTime = ivRewardPlayValue
                    console.log('=-= 视频播放固定一段时间，自动暂停视频并出现弹窗', triggerTime, currentCampaign.video_length, ivreward)
                    videoElement.addEventListener('timeupdate', e => {
                        if (dialogHasNotShowOnce && videoElement.currentTime >= triggerTime) {
                            dialogHasNotShowOnce = false
                            videoElement.pause()
                            IVDialog.show()
                        }
                    })
                    break;
                default:
                    console.warn('=-= 无法识别的 playMode，不再初始化后续逻辑')
                    break;
            }
        } else {
            console.warn('=-= IV 没有匹配到 RewardMode，不再初始化后续逻辑', ivRewardMode)
        }
    }

    /**
     *
     * @param IVDialog
     */
    static closeVideoTemplate(IVDialog) {
        // TODO
        //  1. 目前是直接 closeAd 关闭广告，后续需要支持 "关闭视频模板并根据配置走跳转 ec 或其他"
        //  2. ad_tracking 上报
        App.closeAd()
        IVDialog && typeof IVDialog.hide === 'function' && IVDialog.hide()
    }

    static initVideoCloseButton({appSetting, unitSetting}) {
        // 初始化关闭按钮
        let videoCloseButton = new CloseButton()
        // 设置关闭按钮倒计时出现逻辑
        let video_skip_time = unitSetting && unitSetting.video_skip_time
        console.log(`=-= ${video_skip_time} 秒后出现关闭按钮`)
        if (video_skip_time >= 0) {
            videoCloseButton.showByTimeout({
                countdown: video_skip_time,
                callbackBeforeShow: () => {
                    // 如果用户主动隐藏了关闭按钮（如：通过点击 IV 弹窗中的 "继续"），则后续播放过程中不再展示
                    if (videoCloseButtonHideByUser) {
                        console.warn('=-= 请注意，用户之前主动隐藏了关闭按钮，所以倒计时结束时不再展示')
                        return false
                    } else {
                        return true
                    }
                }
            })
        } else {
            console.warn('=-= 当前 video_skip_time 配置了 -1 或其他无效值，视频播放期间不再展示关闭按钮')
        }

        return videoCloseButton
    }

    static RVCloseAlertEnabled(unitSetting) {
        return unitSetting && unitSetting.close_alert === 1;
    }

    static IVRewardEnabled(appSetting) {
        return appSetting && appSetting.ivreward && appSetting.ivreward.ivRewardEnable === 1;
    }
}

export default SingleVideoRewardManager